import BasicResultModel from "../../domain/model/basic_result_model";
import AvatarRepository from "../../domain/repository/avatar_repository";

export default class AvatarRepositoryImpl extends AvatarRepository {
  static #instance = null;

  constructor(avatarAPIService) {
    if (AvatarRepositoryImpl.#instance) {
      return AvatarRepositoryImpl.#instance;
    }

    super(avatarAPIService);

    AvatarRepositoryImpl.#instance = this;
  }

  async getAvatarDetailsByKey(key) {
    try {
      const result = await this.avatarAPIService.getAvatarDetails({
        key: "key",
        value: key,
      });
      return new BasicResultModel(result.success, result.message, result.data);
    } catch (e) {
      return new BasicResultModel(false, "Failed to fetch avatar details");
    }
  }

  async getAvatarDetailsById(id) {
    try {
      const result = await this.avatarAPIService.getAvatarDetails({
        key: "id",
        value: id,
      });
      return new BasicResultModel(result.success, result.message, result.data);
    } catch (e) {
      return new BasicResultModel(false, "Failed to fetch avatar details");
    }
  }
}
